import { Typography } from '@mui/material';
import { ProfileDetailsSection } from './ProfileDetailsSection';
import { ResetPassword } from './ResetPasswordSection';

export const Profile = () => {
  return (
    <div className="flex flex-col w-full">
      <div className="mb-10">
        <Typography variant="h4" fontWeight={500}>
          Profile settings
        </Typography>
      </div>

      <div className="flex gap-8">
        <div className="flex-1 basis-1/2">
          <div className="mb-10">
            <Typography variant="h5" fontWeight={500}>
              Change company details
            </Typography>
          </div>
          <ProfileDetailsSection />
        </div>
        <div className="flex-1 basis-1/2">
          <div className="mb-10">
            <Typography variant="h5" fontWeight={500}>
              Change password
            </Typography>
          </div>
          <ResetPassword />
        </div>
      </div>
    </div>
  );
};
